import React from 'react';
import {Box, Typography} from '@material-ui/core';
import {Search as SearchIcon, Info as InfoIcon} from '@material-ui/icons';

const SearchNoResults = ({isLoading}: {isLoading: boolean}) => {
    if (isLoading) {
        return (
            <Box className="search-table-empty">
                <SearchIcon />
                <Typography gutterBottom variant="h6" component="h6">
                    Use the search tools to the left to find content items
                </Typography>
            </Box>
        );
    }
    return (
        <Box className="search-table-empty search-table-empty-no-match">
            <InfoIcon />
            <Typography gutterBottom variant="h6" component="h6">
                Couldn’t find any Content Items matching your search.
            </Typography>
        </Box>
    );
};

export default SearchNoResults;
